<template>
  <LayoutDefault title="Dashboard" :show-side-bar="showSideBar">
    <template v-slot:headerLayout>
      <button v-if="cards.hide.length > 0" class="btn btn-outline-primary" @click="restoreDefaultCards">
        {{ $t('dashboard.botao_restaurar') }}
      </button>
    </template>

    <div class="row">
      <ResultPerHour
          v-if="!cards.hide.includes('resultados-hora')"
          @close="removeCard('resultados-hora')"
          class="col-lg-3 col-md-6 col-sm-12 mb-3 resultados-hora"
      />
      <EquipamentsActive
          v-if="!cards.hide.includes('equipamentos-ativos')"
          @close="removeCard('equipamentos-ativos')"
          class="col-lg-3 col-md-6 col-sm-12 mb-3 equipamentos-ativos"
      />
      <EquipamentsInactive
          v-if="!cards.hide.includes('equipamentos-inativos')"
          @close="removeCard('equipamentos-inativos')"
          class="col-lg-3 col-md-6 col-sm-12 mb-3 equipamentos-inativos"
      />
      <TotalEquipaments
          v-if="!cards.hide.includes('total-equipamentos')"
          @close="removeCard('total-equipamentos')"
          class="col-lg-3 col-md-6 col-sm-12 mb-3 total-equipamentos"
      />
    </div>

    <b-card-group class="card-deck-two-line" deck>

      <!--
      <CardCloseMaximize
          v-if="!cards.hide.includes('widget-hexagon')"
          :full-screen="fullScreen.widgetHexagon"
          :title="$t('dashboard.cards.equipment')"
          @maximize="fullScreen.widgetHexagon = !fullScreen.widgetHexagon"
          @close="removeCard('widget-hexagon')"
          class="card-mh-400 widget-hexagon"
      >
        <vnsColoredByRanges/>
      </CardCloseMaximize>
      -->

      <CardCloseMaximize
          v-if="!cards.hide.includes('desempenho')"
          :full-screen="fullScreen.desempenho"
          :title="$t('dashboard.cards.performance')"
          @maximize="fullScreen.desempenho = !fullScreen.desempenho"
          @close="removeCard('desempenho')"
          class="desempenho"
      >
        <b-dropdown variant="outline-secondary btn-sm" :text="$t('dashboard.cards.filtrar')">
          <b-dropdown-item @click="hourPerformance = 4">4 {{ $t('dashboard.cards.horas_atras') }}
          </b-dropdown-item>
          <b-dropdown-item @click="hourPerformance = 8">8 {{ $t('dashboard.cards.horas_atras') }}
          </b-dropdown-item>
          <b-dropdown-item @click="hourPerformance = 16">16 {{ $t('dashboard.cards.horas_atras') }}
          </b-dropdown-item>
          <b-dropdown-item @click="hourPerformance = 24">24 {{ $t('dashboard.cards.horas_atras') }}
          </b-dropdown-item>
        </b-dropdown>
        <PerformancePanel :hourAgo="hourPerformance"/>
      </CardCloseMaximize>

      <!--
      <CardCloseMaximize
          v-if="!cards.hide.includes('validacao-controle-qualidade')"
          :full-screen="fullScreen.qualidade"
          :title="$t('dashboard.cards.qualityControl')"
          @maximize="fullScreen.qualidade = !fullScreen.qualidade"
          @close="removeCard('validacao-controle-qualidade')"
          class="validacao-controle-qualidade"
      >
        <QualityControl/>
      </CardCloseMaximize>
      -->

      <CardCloseMaximize
          v-if="!cards.hide.includes('resultados')"
          :title="$t('dashboard.cards.results')"
          :full-screen="fullScreen.resultados"
          class="resultados"
          @maximize="fullScreen.resultados = !fullScreen.resultados"
          @close="removeCard('resultados')"
      >
        <LatestResult/>
      </CardCloseMaximize>

      <!--
      <CardCloseMaximize
          v-if="!cards.hide.includes('triggers')"
          :title="$t('dashboard.cards.triggers')"
          :full-screen="fullScreen.triggers"
          class="triggers"
          @maximize="fullScreen.triggers = !fullScreen.triggers"
          @close="removeCard('triggers')"
      >
        <TriggerWidget/>
      </CardCloseMaximize>
      -->

      <CardCloseMaximize
          v-if="!cards.hide.includes('logs')"
          :title="$t('dashboard.cards.equipmentLogs')"
          :full-screen="fullScreen.logs"
          class="logs"
          @maximize="fullScreen.logs = !fullScreen.logs"
          @close="removeCard('logs')"
      >
        <vnsLogsPanel/>
      </CardCloseMaximize>
    </b-card-group>

    <v-tour name="Dashboard" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
              v-if="tour.currentStep === index"
              v-for="(step, index) of tour.steps"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button v-if="tour.currentStep === 0" @click="tour.stop" class="btn v-step__button">
                  {{ $t('dashboard.tour.buttons.pular_tour') }}
                </button>
                <button v-else @click="tour.previousStep" class="btn v-step__button">
                  {{ $t('dashboard.tour.buttons.voltar') }}
                </button>
                <button v-if="tour.currentStep === tour.steps.length-1" @click="tour.stop"
                        class="btn v-step__button">
                  {{ $t('dashboard.tour.buttons.finalizar') }}
                </button>
                <button v-else @click="tour.nextStep" class="btn v-step__button">
                  {{ $t('dashboard.tour.buttons.proximo') }}
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
  </LayoutDefault>
</template>

<script>
import CardCloseMaximize from "@/pages/dashboard/components/CardCloseMaximize";
import LatestResult from '@/pages/dashboard/components/LatestResult'
import PerformancePanel from '@/pages/dashboard/components/PerformancePanel'
//import QualityControl from '@/pages/dashboard/components/QualityControl'
import LayoutDefault from "@/templates/LayoutDefault";
//import TriggerWidget from '@/pages/triggers/components/TriggerWidget'
//import vnsColoredByRanges from '@/pages/vns/components/vnsColoredByRanges'
import vnsLogsPanel from '@/pages/vns/components/vnsLogPanel'
import EquipamentsActive from '@/pages/vns/components/widgets_resume/EquipamentsActive'
import EquipamentsInactive from '@/pages/vns/components/widgets_resume/EquipamentsInactive'
import ResultPerHour from '@/pages/vns/components/widgets_resume/ResultPerHour'
import TotalEquipaments from '@/pages/vns/components/widgets_resume/TotalEquipaments'
import {ENABLE_MENU_DASHBOARD} from '@/providers/EnvironmentProvider'
import {default as localStorage} from "@/providers/SessionStorage"
import {mapActions} from 'vuex'

export default {
  name: 'Dashboard',
  components: {
    CardCloseMaximize,
    LayoutDefault,
    PerformancePanel,
    //vnsColoredByRanges,
    vnsLogsPanel,
    //QualityControl,
    LatestResult,
    ResultPerHour,
    TotalEquipaments,
    EquipamentsActive,
    EquipamentsInactive,
    //TriggerWidget,
    localStorage,
    ENABLE_MENU_DASHBOARD
  },
  data() {
    return {
      steps: [
        {
          target: '.resultados-hora',
          content: this.$t('dashboard.tour.descricao.resultados_hora')
        },
        {
          target: '.equipamentos-ativos',
          content: this.$t('dashboard.tour.descricao.equipamentos_ativos')
        },
        {
          target: '.equipamentos-inativos',
          content: this.$t('dashboard.tour.descricao.equipamentos_inativos')
        },
        {
          target: '.total-equipamentos', // We're using document.querySelector() under the hood
          content: this.$t('dashboard.tour.descricao.equipamentos_total')
        },
        {
          target: '.widget-hexagon',
          content: this.$t('dashboard.tour.descricao.equipment'),
          params: {
            placement: 'left'
          }
        },
        {
          target: '.desempenho',
          content: this.$t('dashboard.tour.descricao.performance'),
          params: {
            placement: 'right'
          }
        },
        {
          target: '.validacao-controle-qualidade',
          content: this.$t('dashboard.tour.descricao.qualityControl'),
          params: {
            placement: 'left'
          }
        },
        {
          target: '.resultados',
          content: this.$t('dashboard.tour.descricao.results'),
          params: {
            placement: 'right'
          }
        },
        {
          target: '.triggers',
          content: this.$t('dashboard.tour.descricao.triggers'),
          params: {
            placement: 'left'
          }
        },
        {
          target: '.logs',
          content: this.$t('dashboard.tour.descricao.equipmentLogs'),
          params: {
            placement: 'left'
          }
        }
      ],
      fullScreen: {
        widgetHexagon: false,
        desempenho: false,
        qualidade: false,
        resultados: false,
        triggers: false,
        logs: false
      },
      hourPerformance: 24,
      cards: {
        hide: []
      },
      showSideBar: true,
      permissions: []
    }
  },
  methods: {
    ...mapActions([
      'vns/listToMonitor'
    ]),
    liberarExame() {
      this.$snotify.confirm(this.$t('dashboard.liberar_exame.deseja_desbloquear'), this.$t('dashboard.liberar_exame.desbloquear'), {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          {
            text: this.$t('dashboard.liberar_exame.sim'),
            action: () => console.log('Clicked: Yes'),
            bold: false
          },
          {text: this.$t('dashboard.liberar_exame.nao'), action: () => console.log('Clicked: No')},
          {
            text: this.$t('dashboard.liberar_exame.fechar'),
            action: toast => {
              console.log('Clicked: No');
              this.$snotify.remove(toast.id)
            },
            bold: true
          }
        ]
      })
    },
    restoreDefaultCards() {
      localStorage.remove('cache.dashboard.card.exclude');
      this.cards.hide = []
    },
    removeCard(cardName) {
      const current = localStorage.getObject('cache.dashboard.card.exclude') ? localStorage.getObject('cache.dashboard.card.exclude') : [];
      localStorage.setObject('cache.dashboard.card.exclude', [cardName, ...current]);
      this.cards.hide = [cardName, ...current]
    }
  },
  async mounted() {
    await this['vns/listToMonitor']()
    this.showSideBar = ENABLE_MENU_DASHBOARD !== 'false';
    this.$tours['Dashboard'].start();
    this.cards.hide = localStorage.getObject('cache.dashboard.card.exclude') ? localStorage.getObject('cache.dashboard.card.exclude') : []
  }
}
</script>

<style lang="scss" scoped>
.panel-fullscreen {
  display: block !important;
  z-index: 1000 !important;
  position: fixed !important;
  width: 100% !important;
  height: 100% !important;
  top: 0 !important;
  right: 0 !important;
  left: 0 !important;
  bottom: 0 !important;
  overflow: auto !important;
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.v-tour__target--highlighted {
  box-shadow: 0 0 0 99999px rgba(0, 0, 0, .4);
}

.card-deck-two-line {
  .card {
    flex-grow: 0 !important;
    flex-shrink: 0 !important;
    flex-basis: calc(50% - 1.5rem) !important;
    margin-bottom: 1rem !important; /* mb-3 */
    @media (max-width: 1200px) {
      flex-basis: calc(100% - 1.5rem) !important;
    }
  }
}

.card-header {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  &__ {
    &title {
      flex: 1;
    }

    &actions {
      cursor: pointer;

      &__ {
        &dropdown {
          /deep/ button {
            border: none;
            padding: 0 5px;
          }
        }
      }
    }
  }
}

/deep/.card-mh-400:not(.panel-fullscreen) > .card-body {
  max-height: 400px;
  overflow: scroll;
}
</style>
